import { firstValueFrom } from 'rxjs';
import Swal from 'sweetalert2';

import { SalesService } from '@app/sales/sales.service';
import { SpinnerService } from '@app/shared/spinner.service';
import { periodHardLimit, periodLimitPhrase } from '@app/shared/_models/sales';

// Même garde de caisse que QuotationComponent.onSubmit : Z obligatoire = refus, fin théorique dépassée = confirmation ; périodes illisibles = le serveur tranche.
export async function periodAllowsSave(salesService: SalesService, spin: SpinnerService, label: string): Promise<boolean> {
  let periods: any = null;
  try {
    periods = await firstValueFrom(salesService.getPeriods().pipe(spin.block(label)));
  } catch (e) {
    console.error('[RentalContract] périodes de caisse illisibles : le serveur tranchera', e);
  }
  const day = periods?.success && periods?.data?.length === 3 ? periods.data[2] : null;
  if (!day || day.status !== 'open') return true;
  const now = Date.now();
  if (now >= periodHardLimit(day.end_date, day.z_report_hard_limit_date)) {
    Swal.fire({ title: 'Clôture obligatoire', text: `La session de caisse a dépassé ${periodLimitPhrase(day.end_date, day.z_report_hard_limit_date)}. Vous devez effectuer un Z de caisse.`, icon: 'error', confirmButtonText: 'Compris' });
    return false;
  }
  if (now >= new Date(day.end_date).getTime()) {
    const r = await Swal.fire({ title: 'Attention', text: 'La fin théorique de la période est dépassée. Il est conseillé de clôturer la caisse. Voulez-vous quand même continuer ?', icon: 'warning', showCancelButton: true, confirmButtonText: 'Oui, continuer', cancelButtonText: 'Annuler' });
    return r.isConfirmed;
  }
  return true;
}
